import { useAxios } from './axios-hook';

export function useApi(action, opts) {
  const { loading, data, error, refetch, setApiState } = useAxios(action, opts);

  return [{ loading, data, error, setApiState }, refetch];
}
